export default defineNuxtRouteMiddleware(async (to, from) => {
  if (import.meta.client) {
    const {$propelAuth} = useNuxtApp();
    const user = await $propelAuth.getAuthenticationInfoOrNull();
    if (!user) return $propelAuth.redirectToLoginPage({postLoginRedirectUrl: window.location.href});
    await apiFetch('/orgs', {method: 'POST'});
    const org = await apiFetch('/orgs');
    useState('org', () => org);
    if (
      new Date(org.created_at) > new Date('2025-05-31') &&
      !org.settings?.onboardingCompleted &&
      !to.path.startsWith('/onboarding') &&
      !to.path.startsWith('/partner-integrations') &&
      !to.path.startsWith('/integrations/')
    ) {
      window.location.href = '/onboarding';
      return;
    }
  }
});
